query latestAppVersion {
  latestAppVersion
}
